<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      :seq-config="{}"
      size="mini"
    >
      <template v-slot:uploadByImgUrl="{ row }">
        <!-- <b-avatar :src="row.memImgUrl ? $osscdn(row.memImgUrl) : ''"></b-avatar> -->
        <span class="ml-3">{{ row.userNameEn }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_downloada') || '下载'"
            placement="top"
          >
            <i class="el-icon-download tool-btn" @click="dowloadFile(row)"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    params: {
      default: null,
      type: Object
    }
  },
  watch: {
    params: {
      handler() {
        if (this.params.scmCode) {
          this.init(this.params)
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      isBusy: false,

      loading: false,
      tableData: [],
      tableHeight: 150,
      tableColumn: [
        {
          field: 'col-opt',
          title: '',
          align: 'center',
          width: 50,
          fixed: 'left',
          slots: {
            default: 'opt'
          }
        },
        // {
        //   field: 'seq',
        //   width: 60,
        //   align: 'center',
        //   type: 'seq'
        // },
        {
          field: 'scmImageDesc',
          minWidth: 250,
          title: this.$l('label_file_desc') || '文件说明'
        },
        {
          field: 'userNameEn',
          width: 150,
          title: this.$l('label_image_uploadby') || '上传人',
        },
        {
          field: 'createTime',
          width: 170,
          title: this.$l('label_image_createTime') || '上传时间'
        }
      ]
    }
  },
  mounted() {},
  methods: {
    init(params) {
      this.getData(params)
    },
    getData(params) {
      this.isBusy = true
      this.$api
        .scmInfoImageListApi(params)
        .then((res) => {
          this.isBusy = false
          let data = this.filterImage(res.body.data)
          this.tableData = data
        })
        .catch(() => {
          this.isBusy = false
        })
    },
    //过滤图片数据
    filterImage(data) {
      const filter = ['jpeg', 'png', 'jpg', 'gif']
      return data.filter((item) => {
        return !filter.includes(
          item.scmImageCode.substring(item.scmImageCode.indexOf('.') + 1)
        )
      })
    },
    // 下载文件
    dowloadFile(row) {
      window.open(this.$osscdn(row.scmImageUrl))
    }
  }
}
</script>
